import { Components } from '.generated/templates/Feature.Components.model';
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import { classnames } from 'tailwindcss-classnames';
import EditingHelpText, { MissingDataSource } from 'components/helpers/EditingHelpText';
import VideoItem, { VideoItemProps } from 'components/helpers/VideoItem/VideoItem';

export type VideoProps = Sitecore.Override.ComponentBase &
  Components.General.Video.Fields.Video & {
    fields: {
      selectVideo: VideoItemProps;
    };
  };
const Video = ({ fields }: VideoProps): JSX.Element => {
  if (!fields) {
    return <MissingDataSource />;
  }

  return (
    <div data-component="authorable/general/video" className={classnames('mt-4', 'first:mt-0')}>
      <div>
        {fields.selectVideo ? (
          <VideoItem
            {...fields.selectVideo}
            videoSide={fields.videoSide}
            videoTitleHeadlineLevel={fields.videoTitleHeadlineLevel}
            videoTitleHeadlineSizing={fields.headingSize}
          />
        ) : (
          <EditingHelpText text="Video Component | No Video Selected. " />
        )}
      </div>
    </div>
  );
};
export default Video;
